/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  // Select,
  Modal,
  Table,
  Tooltip,
  Typography,
  Switch,
  Skeleton,
  Badge,
  DatePicker,
  Dropdown,
  // Popover,
} from "antd";
import {
  SettingOutlined,
  // SearchOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileTextOutlined,
  DownOutlined,
  // FileExcelOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import { salesHeaders, items } from "./data";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteSalesInvoiceList,
  loadSalesInvoice,
  loadSalesTotal,
  loadTotalPaid,
  loadTotalUnPaid,
} from "../../store/sales-invoice/actions";
import { BiCalendar } from "react-icons/bi";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import useMedia from "use-media-antd-query";
import { loadPrefixSettingsList } from "../../store/expenses/actions";
import api from "../../helpers";

const SalesInvoice = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { RangePicker } = DatePicker;

  //state initial
  const [salesTab, setSalesTab] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectDays, setSelectDays] = useState([]);
  const [search, setSearch] = useState("");

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  console.log(userId, "userId");
  const salesInvoiceList = { organizationId: organizationId };
  const salesPrefixList = { organizationId: organizationId, isType: "isSales" };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadSalesInvoice(salesInvoiceList));
    dispatch(loadSalesTotal(salesInvoiceList));
    dispatch(loadTotalPaid(salesInvoiceList));
    dispatch(loadTotalUnPaid(salesInvoiceList));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const {
    sales_invoice_list = [],
    sales_total_list = [],
    total_paid_list = [],
    total_unpaid_list = [],
  } = useSelector((state) => state.SalesInvoice);
  const { prefix_settings_list = [] } = useSelector((state) => state.Expenses);

  //States data
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [salesInvoiceData, setSalesInvoiceData] = useState({
    prefix: "",
    seqNo: "",
  });

  const media = useMedia();
  const handleChange = (e) => {
    setSalesInvoiceData({
      ...salesInvoiceData,
      [e.target.name]: e.target.value,
    });
  };

  // const [searchOpen, setSearchOpen] = useState(false);

  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //header columns
  const HeaderData = [
    {
      key: "salesinvoiceDate",
      title: <p className="header-sales-invoice font-semibold">Date</p>,
      dataIndex: "salesinvoiceDate",
      width: 130,
      // fixed: "left",
      sorter: (a, b) => a.salesinvoiceDate.length - b.salesinvoiceDate.length,
    },
    {
      key: "salesinvoiceNo",
      title: <p className="header-sales-invoice font-semibold">Invoice No</p>,
      dataIndex: "salesinvoiceNo",
      width: 140,
    },
    {
      key: "partyName",
      title: <p className="header-sales-invoice font-semibold">Party Name</p>,
      dataIndex: "partyName",
      width: 120,
    },
    {
      key: "dueIn",
      title: <p className="header-sales-invoice font-semibold">Due In</p>,
      dataIndex: "dueIn",
      width: 110,
    },
    {
      key: "netTotalAmount",
      title: <p className="header-sales-invoice font-semibold">Amount</p>,
      dataIndex: "netTotalAmount",
      width: 120,
    },
    {
      key: "status",
      title: <p className="header-sales-invoice font-semibold">Status</p>,
      dataIndex: "status",
      width: 120,
    },
  ];

  const salesInvoiceRoutes = (data) => {
    history.push({
      pathname: "/sales-invoice/data",
      state: {
        salesInvoice: data,
        paid: total_paid_list.totalPaidAmount,
        unpaid: total_unpaid_list.totalUnPaidAmount,
      },
    });
  };

  //purchase rows

  const [salesInvoiceRows, setSalesInvoiceRows] = useState([
    {
      _id: "",
      key: "",
      netTotalAmount: "",
      amountreceivedmode: "",
      balanceAmount: "",
      amountreceived: "",
      authorizedsignature: "",
      autoroundoff: "",
      autoroundoffamount: "",
      beforeautoroundoffamount: "",
      charge: "",
      createdAt: "",
      createdBy: "",
      financialyearId: "",
      isHistory: "",
      items: "",
      notes: "",
      organizationId: "",
      // amount: "",
      salesinvoiceNo: "",
      salesinvoiceDate: "",
      partyId: "",
      partyAddress: "",
      status: "",
      subtotalamount: "",
      taxableAmonut: "",
      termsandconditions: "",
      totaltax: "",
      totaltaxableValue: "",
      transActionType: "",
      type: "",
      updatedAt: "",
      vendorAddress: "",
      vendorCity: "",
      // partyId: "",
      partyName: "",
      partyNameValue: "",
    },
  ]);

  console.log(sales_invoice_list, "sales_invoice_list");
  //data table
  const salesInvoiceDataTable =
    sales_invoice_list && sales_invoice_list.length > 0
      ? sales_invoice_list.map((data, index) => {
          const poDateValue = data.salesinvoiceDate ? moment() : 0;
          const poValidTill = data.dueDate ? moment(data.dueDate) : 0;

          const validTill = poValidTill.diff(poDateValue, "days");
          console.log(validTill, "validTill");
          // const netAmount = data.NetAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
          // console.log(netAmount, "netAmount")
          const splitData = {
            items: data.items.flatMap((item) =>
              item.serialDetails.map((serial) => ({
                itemId: item.itemId,
                modelName: item.modelName,
                brandName: item.brandName,
                brandId: item.brandId,
                qty: Number(item.qty / item.serialDetails.length), // Adjusted for each split item
                serialDetail: serial,
                _id: item._id,
              }))
            ),
          };
          return {
            _id: data._id,
            key: index + 1,
            netTotalAmount: (
              <div className="flex">
                <p>{"₹ "}</p>
                <h1
                  className="cursor-pointer ml-1 header-sales-invoice"
                  onClick={() => salesInvoiceRoutes(data)}
                >
                  {data.netTotalAmount.toLocaleString("en-IN")}
                </h1>
              </div>
            ),
            salesinvoiceNo: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.salesinvoiceNo}
              </h1>
            ),
            salesinvoiceDate: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.salesinvoiceDate
                  ? moment(data.salesinvoiceDate).format("DD-MM-YYYY")
                  : "--"}
              </h1>
            ),
            authorizedsignature: data.authorizedsignature,
            autoroundoff: data.autoroundoff,
            autoroundoffamount: data.autoroundoffamount,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            // partyId: data.partyId,
            items: splitData && splitData.items,
            notes: data.notes,
            organizationId: data.organizationId,
            partyAddress: data.partyAddress,
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            balanceAmount: data.balanceAmount,
            accountDetails: data.accountDetails,
            amountreceivedmode: data.amountreceivedmode,
            amonutreceivedmodeName: data.amonutreceivedmodeName,
            amountreceived: data.amountreceived,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            billStatus: data.billStatus,
            partyId: data.partyId,
            partyName: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.partyName}
              </h1>
            ),
            partyNameValue: data.partyName,
            dueIn: (
              <h1
                className="cursor-pointer header-sales-invoice"
                onClick={() => salesInvoiceRoutes(data)}
              >
                <Badge
                  className={
                    data.salesinvoiceDate && validTill > 10
                      ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                      : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                  }
                >
                  {data.salesinvoiceDate && validTill > 1
                    ? validTill + " Days"
                    : validTill == 1
                    ? validTill + " Day"
                    : validTill <= 0
                    ? "Expired"
                    : ""}
                </Badge>
              </h1>
            ),
            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold header-sales-invoice rounded-md text-[#49a563] text-[12px] p-2"
                    : "bg-[#f1e7e9] font-semibold header-sales-invoice rounded-md text-[#d01717] text-[12px] p-2"
                }
                onClick={() => salesInvoiceRoutes(data)}
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (salesInvoiceDataTable && salesInvoiceDataTable.length > 0) {
      setSalesInvoiceRows(salesInvoiceDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sales_invoice_list]);

  //expand row
  const expandColumns = [
    {
      title: <p className="header-expand-purchase-invoice">Model</p>,
      dataIndex: "modelName",
      key: "modelName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Barcode</p>,
      dataIndex: "barcode",
      key: "barcode",
    },
    {
      title: <p className="header-expand-purchase-invoice">IMEI</p>,
      key: "IMEI",
      dataIndex: "IMEI",
    },
    {
      title: <p className="header-expand-purchase-invoice">Grade Name</p>,
      dataIndex: "gradeName",
      key: "gradeName",
    },
    {
      title: <p className="header-expand-purchase-invoice">Quantity</p>,
      key: "qty",
      dataIndex: "qty",
    },
    {
      title: <p className="header-expand-purchase-invoice">Selling Price</p>,
      dataIndex: "sellingPrice",
      key: "sellingPrice",
    },
    {
      title: <p className="header-expand-purchase-invoice">Discount Price</p>,
      dataIndex: "discountAmount",
      key: "discountAmount",
    },
    {
      title: <p className="header-expand-purchase-invoice">Total Amount</p>,
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
  ];

  // expand row
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const onTableRowExpand = (expanded, record) => {
    console.log(record, "record");
    const keys = [];
    if (expanded) {
      keys.push(record._id); // I have set my record.id as row key. Check the documentation for more details.
    }

    setExpandedRowKeys(keys);
  };
  const expandedRowRender = (row) => {
    const expandRowData =
      row && row.items && row.items.length > 0
        ? row.items.map((serialDetails) => {
            const serialDetailsArray =
              serialDetails.serialDetail && serialDetails.serialDetail
                ? serialDetails.serialDetail
                : "";
            console.log(serialDetailsArray, "serialDetailsArray");
            return {
              modelName: serialDetails.modelName
                ? serialDetails.modelName
                : "--",
              gradeName: serialDetailsArray
                ? serialDetailsArray.gradeName
                : "--",
              qty: serialDetails.qty ? serialDetails.qty : "--",
              barcode: serialDetailsArray ? serialDetailsArray.barCodeNo : "--",
              IMEI: serialDetailsArray ? serialDetailsArray.IMEI : "--",
              totalAmount:
                serialDetailsArray && serialDetailsArray.totalAmount
                  ? parseFloat(serialDetailsArray.totalAmount).toFixed(2)
                  : "--",
              sellingPrice:
                serialDetailsArray && serialDetailsArray.sellingPrice
                  ? parseFloat(serialDetailsArray.sellingPrice).toFixed(2)
                  : "--",
              discountAmount: serialDetailsArray
                ? serialDetailsArray.discountAmount
                : "--",
              // purchasePrice: serialDetails ? serialDetails.purchasePrice : "--",
            };
          })
        : [];
    return (
      <Table
        columns={expandColumns}
        dataSource={expandRowData}
        pagination={false}
        rowClassName={"header-expand-purchase-invoice-column"}
      />
    );
  };

  //data table
  const hasSelected = selectedRowKeys.length > 0;

  const handleSearch = (event) => {
    const filteredRows = salesInvoiceDataTable
      .filter((row) =>
        row.partyNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setSalesInvoiceRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  console.log(salesInvoiceRows, "salesInvoiceRows");
  const [deleteSalesInvoiceModal, setDeleteSalesInvoiceModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  //deletPurchase api integrations
  const deleteSalesInvoiceApi = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    const itemListData = {
      organizationId: organizationId,
      siId:
        selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deleteSalesInvoiceList(itemListData));
    setTimeout(() => {
      dispatch(loadSalesInvoice(salesInvoiceList));
      setDeleteSalesInvoiceModal(false);
      setSelectedRowKeys([]);
      toast.error("Sales invoice deleted successfully");
    }, 1000);
  };

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(selectDays),
    message: "Are you sure you want to leave?",
  });
  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //import invoice
  // const bulkActions = (
  //   <div>
  //     <div
  //       onClick={() => {
  //         history.push({
  //           pathname: "/sales-invoice/import",
  //           state: { mode: "IMEI" },
  //         });
  //       }}
  //       className="hover:rounded-md hover:bg-[lightgray] hover:mr-[-3px] flex justify-between w-[270px] h-[45px] mt-[2px] pl-3 pr-2 pt-2 pb-12 cursor-pointer"
  //     >
  //       <div>
  //         <p className="flex text-[14px] font-semibold">
  //           <FileExcelOutlined className="mr-2" /> Bulk Import IMEI
  //         </p>
  //         <p className="mt-1 text-[12px]">
  //           Quickly add all your IMEI Details with Excel
  //         </p>
  //       </div>
  //       <BiRightArrowAlt size={24} />
  //     </div>
  //     <div
  //       onClick={() => {
  //         history.push({
  //           pathname: "/sales-invoice/import",
  //           state: { mode: "Qty" },
  //         });
  //       }}
  //       className="border border-b-0 border-x-0 border-t-1 hover:bg-[lightgray] hover:rounded-md hover:mr-[-3px] flex justify-between w-[270px] h-[55px] mt-[10px] mb-1 pl-3 pr-2 pt-2 pb-8 cursor-pointer"
  //     >
  //       <div>
  //         <p className="flex text-[14px] font-semibold">
  //           <FileExcelOutlined className="mr-2" /> Bulk Import Qty
  //         </p>
  //         <p className="mt-1 text-[12px]">
  //           Quickly add all your qty details with Excel
  //         </p>
  //       </div>
  //       <BiRightArrowAlt size={24} />
  //     </div>
  //   </div>
  // );

  //Prefix settings list
  const createPrefixSettings = () => {
    if (salesInvoiceData.prefix && salesInvoiceData.seqNo) {
      const prefixList = {
        organizationId: organizationId,
        prefix: salesInvoiceData.prefix,
        sequenceNo: salesInvoiceData.seqNo,
        isEnable: invoiceShow ? true : false,
        isType: "isSales",
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(salesPrefixList));
          toast.success("Prefix updated successfully");
          setSettingsFieldModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setSettingsFieldModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && !isEmpty(prefix_settings_list._id)) {
      setSalesInvoiceData({
        ...salesInvoiceData,
        prefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
      });
      setInvoiceShow(true);
    } else {
      setSalesInvoiceData({
        ...salesInvoiceData,
        prefix: "",
        seqNo: "",
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Sales Invoices | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] mt-2 font-semibold"
              >
                Sales Invoices
              </h1>
            </div>
            <div className="flex">
              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
                className="text-[#0c8ce9] rounded-md"
              >
                <Tooltip
                  title="See all your party specific reports"
                  placement="left"
                  rootClassName="text-[10px]"
                >
                  <div
                    style={{
                      border: "1px solid #9ed1f6",

                      fontFamily: "Poppins",
                    }}
                    className="border flex justify-between w-[180px] pl-3 pr-2 pt-2 pb-2 cursor-pointer"
                  >
                    <div>
                      <FileTextOutlined /> Reports
                    </div>
                    <DownOutlined />
                  </div>
                </Tooltip>

                {/* </a> */}
              </Dropdown>
              <Tooltip
                title="Easily add the Sales Invoice settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => {
                    setSettingsFieldModal(true);
                    dispatch(loadPrefixSettingsList(salesPrefixList));
                  }}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        <div
          className={
            (windowDimensions.height >= 700 &&
              windowDimensions.height <= 767) ||
            (windowDimensions.height > 767 && windowDimensions.height < 830)
              ? "add-sales-home-main-large-device"
              : windowDimensions.height > 830 && windowDimensions.height < 1000
              ? "add-sales-home-extra-main-large-device"
              : windowDimensions.height > 1000
              ? "add-sales-home-main-infinite-large-device"
              : "add-sales-invoices-home-main"
          }
        >
          <Col span={24}>
            <Row className="pl-5 pr-1 mt-5 mb-5">
              {salesHeaders.map((data) => {
                return (
                  <Col span={8} key={data.key} className="">
                    {loading ? (
                      <div className="pr-1">
                        <Skeleton.Input
                          style={{
                            marginRight: "5px",
                            minWidth: "165%",
                            height: "60px",
                          }}
                          active={true}
                          size={"large"}
                          // block={true}
                        ></Skeleton.Input>
                      </div>
                    ) : (
                      <div
                        className={
                          salesTab === data.label
                            ? "poppins mr-4 sales-select-card sales-card border rounded-md"
                            : data.key !== 3
                            ? "poppins mr-4 sales-card border rounded-md"
                            : "poppins sales-select-card sales-card border rounded-md"
                        }
                        onClick={() => setSalesTab(data.label)}
                      >
                        <div
                          style={{
                            fontSize: "14px",
                            display: "flex",
                            fontFamily: "Poppins",
                            color:
                              data.key == 1
                                ? "blue"
                                : data.key == 2
                                ? "#429559"
                                : "#AE1536",
                          }}
                        >
                          <p className={data.key !== 1 ? "mt-[2px]" : ""}>
                            {data.icon}
                          </p>
                          <h2 className={"ml-2 tracking-wide"}>{data.label}</h2>
                        </div>
                        <div className="ml-1 mt-1 flex">
                          <p className="font-semibold text-[18px]">₹ </p>
                          <h1
                            className="font-semibold tracking-wider ml-1 text-[18px]"
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {data.key == 1
                              ? sales_total_list &&
                                sales_total_list.totalSales &&
                                sales_total_list.totalSales.toLocaleString(
                                  "en-IN"
                                )
                              : data.key == 2
                              ? total_paid_list &&
                                total_paid_list.totalPaidAmount &&
                                total_paid_list.totalPaidAmount.toLocaleString(
                                  "en-IN"
                                )
                              : data.key == 3 &&
                                total_unpaid_list &&
                                total_unpaid_list.totalUnPaidAmount &&
                                total_unpaid_list.totalUnPaidAmount.toLocaleString(
                                  "en-IN"
                                )}
                          </h1>
                        </div>
                      </div>
                    )}
                  </Col>
                );
              })}
            </Row>
          </Col>
          {/* purchase input section with bulk actions */}
          <Col span={24} className="sales-invoice-orders mt-1 mb-2">
            <Row className="sales-invoice-filters-main ml-4">
              <div className="sales-invoice-filters">
                {loading ? (
                  <div
                    style={{
                      marginRight: "10px",
                    }}
                  >
                    <Skeleton.Input
                      style={{
                        width: "100%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <>
                    <Tooltip
                      rootClassName="text-[10px]"
                      title="Search by phone or name"
                      placement="bottom"
                    >
                      {/* {searchOpen ? ( */}
                      <div className="filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                            fontSize: "11px",
                          }}
                          // onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="middle"
                            placeholder="Search Party"
                            style={{
                              fontFamily: "Poppins",
                              minHeight: "35px",
                              fontSize: "11px",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                      {/* // ) : (
                      //   <div
                      //     onClick={() => setSearchOpen(true)}
                      //     className="filter-dropdown-search-filters border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                      //   >
                      //     <SearchOutlined size={16} />
                      //   </div>
                      // )} */}
                    </Tooltip>
                  </>
                )}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      marginRight: "30px",
                      width: "100%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <div
                    style={{
                      marginLeft: "0.75rem",
                      marginRight: "0.75rem",
                      // marginLeft: searchOpen ? "0.75rem" : "0rem",
                    }}
                    className="filter-dropdown-filters"
                  >
                    <RangePicker
                      style={{
                        width: "100%",
                        height: 35,
                        fontFamily: "Poppins",
                      }}
                      placeholder="Select Days"
                      // value={selectDays}
                      onChange={(date, dateString) => {
                        console.log(date, "date");
                        setSelectDays(dateString);
                      }}
                      options={[]}
                      className="mr-3 text-[11px]"
                      allowClear
                      suffixIcon={<BiCalendar size={14} />}
                    />
                  </div>
                )}
              </div>
              <div className="flex">
                {/* {loading ? (
                  <div className="pr-2">
                    <Skeleton.Input
                      style={{
                        marginRight: "5px",
                        width: "100%",
                        height: "35px",
                      }}
                      active={true}
                      size={"large"}
                      // block={true}
                    ></Skeleton.Input>
                  </div>
                ) : (
                  <Popover
                    placement="bottomRight"
                    trigger={"click"}
                    content={bulkActions}
                  >
                    <Tooltip
                      title="Easily perform bulk actions on all your Parties"
                      placement="left"
                      rootClassName="text-[10px]"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "13px",
                        }}
                        className="border h-[33px] rounded-sm flex justify-between pl-3 pr-3 pt-1 pb-1 cursor-pointer"
                      >
                        <div className="pr-1 pt-1">
                          <FileTextOutlined /> Bulk Action
                        </div>
                        <DownOutlined className="pt-1" />
                      </div>
                    </Tooltip>
                  </Popover>
                )} */}
                {loading ? (
                  <Skeleton.Input
                    style={{
                      paddingRight: "25px",
                      marginRight: "25px",
                      width: "90%",
                      height: "35px",
                    }}
                  ></Skeleton.Input>
                ) : (
                  <Button
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="ml-3 bg-[#6007ad] p-4 text-[white] mr-4"
                  >
                    <Link
                      to={{
                        pathname: "/create-sales-invoice",
                        state:
                          sales_invoice_list && sales_invoice_list.length > 0
                            ? sales_invoice_list.length
                            : 1,
                      }}
                    >
                      Create Sales Invoice
                    </Link>
                  </Button>
                )}
              </div>
            </Row>
          </Col>
          <Col span={24} className="pl-4 pr-4 pb-1">
            {hasSelected ? (
              <Row className="flex justify-between mb-2">
                <Col
                  style={{
                    fontFamily: "Poppins",
                    color: "#ffffff",
                    background: "#4096ff",
                    borderRadius: "10px",
                    padding: "5px 10px",
                  }}
                  className="mb-1"
                  span={4}
                >
                  {hasSelected
                    ? `Selected ${selectedRowKeys.length} items`
                    : ""}
                </Col>
                {selectedRowKeys.length > 0 ? (
                  <Col>
                    <Tooltip title="Delete sales invoice" placement="topLeft">
                      <div
                        onClick={() => setDeleteSalesInvoiceModal(true)}
                        className="cursor-pointer border border-1 p-[8px] rounded-md"
                      >
                        <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                      </div>
                    </Tooltip>
                  </Col>
                ) : (
                  ""
                )}
              </Row>
            ) : (
              ""
            )}
          </Col>
          <Col
            span={24}
            className={
              media === "xxl"
                ? "pt-12 pr-4 pl-4 sales-invoice-orders"
                : "pt-5 pr-4 pl-4 sales-invoice-orders"
            }
          >
            <Table
              style={{
                overflow: "hidden",
              }}
              bordered
              columns={HeaderData}
              dataSource={
                salesInvoiceRows &&
                salesInvoiceRows.length > 0 &&
                !isEmpty(salesInvoiceRows[0].createdAt)
                  ? salesInvoiceRows
                  : []
              }
              expandable={{
                expandedRowRender: expandedRowRender,
                defaultExpandAllRows: false,
                expandedRowKeys: expandedRowKeys,
                onExpand: onTableRowExpand,
              }}
              rowKey={(record) => record._id}
              rowClassName={"text-[12px]"}
              pagination={{
                defaultPageSize: 10,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "20", "30"],
              }}
              sortDirections={"ascend"}
              loading={tableLoading ? true : false}
              showSorterTooltip={"sorter-icon"}
              rowSelection={{
                selectedRowKeys,
                onSelectAll: (selectedRowKeys, selectedRows, row) => {
                  const newSelecteds = selectedRows.map((n) => n._id);
                  setSelectedRowKeys(newSelecteds);
                },
                onSelect: (selectedRowKey, selectedRows, row) => {
                  const selectedIndex = selectedRowKeys.indexOf(
                    selectedRowKey._id
                  );
                  let newSelecteds = [];

                  if (selectedIndex === -1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys,
                      selectedRowKey._id
                    );
                  } else if (selectedIndex === 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(1)
                    );
                  } else if (selectedIndex === selectedRowKeys.length - 1) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, -1)
                    );
                  } else if (selectedIndex > 0) {
                    newSelecteds = newSelecteds.concat(
                      selectedRowKeys.slice(0, selectedIndex),
                      selectedRowKeys.slice(selectedIndex + 1)
                    );
                  }
                  setSelectedRowKeys(newSelecteds);
                },
              }}
              scroll={{
                y: windowDimensions.height > 500 ? "100%" : "",

                x: 765,
              }}
            />
          </Col>
        </div>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Sales Invoice Settings"
          onOk={createPrefixSettings}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Sales Invoice Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1">Prefix</Typography>

                  <Input
                    name="prefix"
                    value={salesInvoiceData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(salesInvoiceData.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography className="mb-1">Sequence Number</Typography>

                  <Input
                    name="seqNo"
                    value={salesInvoiceData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(salesInvoiceData.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1">
                    Sales Invoice Number:{" "}
                    {salesInvoiceData.prefix && salesInvoiceData.seqNo
                      ? salesInvoiceData.prefix + "" + salesInvoiceData.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      {/* Delete purchase modal */}

      <Modal
        open={deleteSalesInvoiceModal}
        onOk={() => {
          deleteSalesInvoiceApi();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete SI`}
        cancelText={"Cancel"}
        okButtonProps={{
          disabled: isButtonDisabled ? true : false,
        }}
        okType="danger"
        onCancel={() => setDeleteSalesInvoiceModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these sales invoice?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected sales invoice will be deleted from the sales invoice
            Inventory. Once deleted you will not be able to restore these sales
            invoice.
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(selectDays)}
        message="Are you sure you want to leave?"
      />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

SalesInvoice.propTypes = {
  location: PropTypes.any,
};

export default SalesInvoice;
